export default __webpack_public_path__ + "summary_sales.html";